import React, { ReactNode } from "react";

const Content: React.FC<{ children: ReactNode }> = ({ children }) => (
	<div className="col-md-7 util-padding-horz-md-45 util-padding-horz-sm-60 util-margin-top-sm-0">
		{children}
	</div>
);

export default Content;
